/* 
* WP Theme custom scripts 
*/
// import { Calculator } from './partials/_pastuerisation-calculator';
import './partials/partials';

// document.addEventListener("DOMContentLoaded", function() {
//     const calculators = document.querySelectorAll('.calculator-pasteurisation');
    
//     calculators.forEach((calculator) => {
//         let form = calculator.querySelector('form');
//         let newCalculator = new Calculator(form);
//     })
// });